var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundsDisabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.01,5.52c-0.46,-0.4 -0.93,-0.78 -1.42,-1.15l-2.57,3.48c0.32,0.23 0.63,0.48 0.93,0.73l3.06,-3.06z",
    fill: "#604c7c",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.71,21.61l3.17,-3.16c1.94,3.26 3.05,7.48 3.05,11.98c0,5.74 -1.81,11.01 -4.83,14.45l-3.2,-2.89c2.18,-2.48 3.74,-6.66 3.74,-11.56c0,-3.39 -0.74,-6.44 -1.93,-8.82z",
    fill: "#604c7c",
    id: "svg_2",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.07,15.46l0,-15.03l-22.62,14.82l-15.95,0l0,30.35l8.43,0l4.33,-4.33l-8.47,0l0,-21.68l12.92,0l17.08,-11.19l0,11.34l4.28,-4.28z",
    fill: "#604c7c",
    id: "svg_3",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.79,32.54l4.28,-4.28l0,32.17l-19.44,-12.74l3.13,-3.12l12.03,7.88l0,-19.91z",
    fill: "#604c7c",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.93,15.4l3.11,-3.11c3.45,5.18 5.46,11.42 5.46,18.14c0,10.66 -5.08,20.13 -12.91,26.05l-2.57,-3.47c6.8,-5.14 11.19,-13.34 11.19,-22.58c0,-5.53 -1.57,-10.68 -4.28,-15.03z",
    fill: "#604c7c",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5,3.79l-3.36,-3.36l-56.64,56.63l3.36,3.37l56.64,-56.64z",
    fill: "#604c7c",
    id: "svg_6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundsDisabledMain);
export default __webpack_public_path__ + "static/media/soundsDisabledMain.417fafc3588d97f3912b260cff46ee42.svg";
export { ForwardRef as ReactComponent };